import {createRoot} from 'react-dom/client'
// Axios
import axios from 'axios'
import {Chart, registerables} from 'chart.js'
import {QueryClient, QueryClientProvider} from 'react-query'
// import {ReactQueryDevtools} from 'react-query/devtools'
// Apps
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import {Provider} from 'react-redux'
import './_metronic/assets/sass/custom.scss'
import './_metronic/assets/sass/plugins.scss'
import './_metronic/assets/sass/style.react.scss'
import './_metronic/assets/sass/style.scss'
import {AuthProvider, setupAxios} from './app/modules/auth'
import {AppRoutes} from './app/routing/AppRoutes'
import store from './store/store.js'

// Request interceptor - Add authorization header
axios.interceptors.request.use(
  function (config: any) {
    config.headers.Authorization = localStorage.getItem('token') as any
    
    // Update last activity timestamp on API calls
    try {
      localStorage.setItem('lastActivity', Date.now().toString())
    } catch (error) {
      console.error('Failed to update lastActivity:', error)
    }
    
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

/**
 * Response interceptor - Handle authentication errors and session expiration
 *
 * @see https://github.com/axios/axios#interceptors
 */
axios.interceptors.response.use(
  function (response) {
    // Update last activity on successful response
    try {
      localStorage.setItem('lastActivity', Date.now().toString())
    } catch (error) {
      console.error('Failed to update lastActivity:', error)
    }
    return response
  },
  function (error) {
    // Handle 401 Unauthorized - Session expired or invalid token
    if (error?.response?.status === 401) {
      console.log('Session expired or unauthorized access detected')
      localStorage.clear()
      
      // Redirect to login page
      setTimeout(() => {
        window.location.href = '/auth/login'
      }, 500)
      
      return Promise.reject({
        message: 'Your login session has expired. Please login again.',
        ...error,
      })
    }
    
    // Handle 403 Forbidden
    if (error?.response?.status === 403) {
      return Promise.reject({
        message: 'You do not have permission to access this resource.',
        ...error,
      })
    }
    
    return Promise.reject(error)
  }
)

setupAxios(axios)
Chart.register(...registerables)

const queryClient = new QueryClient()
const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    <QueryClientProvider client={queryClient}>
      <MetronicI18nProvider>
        <Provider store={store}>
          <AuthProvider>
            <AppRoutes />
          </AuthProvider>
        </Provider>
      </MetronicI18nProvider>
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
  )
}
